import {Component, EventEmitter, Output} from "@angular/core";
import {NgForm} from "@angular/forms";
import {DxAppEvent} from "../../../../dx-core/domain/events/dx-app-event";
import {DxCredentialsSubmittedEvent} from "../../../domain/events/dx-credentials-submitted-event";


@Component({
  selector: 'dx-login-form',
  templateUrl: './dx-login-form.component.html',
  styleUrls: ['./dx-login-form.component.css']
})
export class DxLoginFormComponent {
  public loginErrorMsg: string;
  public loginInfo: string;
  private _isValid: boolean = true;

  @Output()
  public submitClick: EventEmitter<DxCredentialsSubmittedEvent> = new EventEmitter();

  @Output()
  public registerClick: EventEmitter<DxAppEvent> = new EventEmitter();

  @Output()
  public forgotPasswordClick: EventEmitter<DxAppEvent> = new EventEmitter();

  constructor() {
    this.loginInfo = 'Обратитесь в службу технической поддержки';
  }



  public onSubmitClick(form: NgForm): void {
    if (form.value.username.length === 0) {
      this.loginErrorMsg = 'Введите логин';
      this._isValid = false;
    } else if (form.value.password.length === 0) {
      this.loginErrorMsg = 'Введите пароль';
      this._isValid = false;
    } else {
      this.submitClick.emit(new DxCredentialsSubmittedEvent('dx-login-form', form.value.username, form.value.password))
    }
  }

  public onForgotPasswordClick() {
    this.forgotPasswordClick.emit(new DxAppEvent('dx-login-form'));
  }

  public onRegisterClick(): void {
    this.registerClick.emit(new DxAppEvent('dx-login-form'))
  }

  /** Внешняя валидация логина и пароля **/
  get isValid(): boolean {
    return this._isValid;
  }

  set isValid(value: boolean) {
    this._isValid = value;
  }
}
